import React, { useEffect, useState } from 'react'
import { Col, Label } from 'reactstrap'
import ReportTypes from './reportTypes'

function ClubBranchSelect(props) {

    const [branches, setBranches] = useState([])
    const [showClubSelect, setShowClubSelect] = useState(false)

    useEffect(() => {
        doSelectFisrtClub()
    }, [])

    const doSelectFisrtClub = _ => {
        let clubId = '-1'
        let clubName = ''
        let showClubSelect = false

        if (props.addEmptyItemClub) {
            const empty = props.clubs.filter(x => x.clubId === clubId)

            if (empty.length === 0) {
                const clubs = props.clubs
                clubs.unshift({ clubId: clubId, name: clubName, clubCode: '' })
            }
        }
        else {
            const empty = props.clubs.filter(x => x.clubId === clubId)
            if (empty.length > 0) {
                const clubs = props.clubs
                console.log(empty)
                if (clubs) {
                    clubs.shift()
                }
            }
        }

        if (props.clubs.length >= 1) {
            clubId = props.clubs[0].clubId
            clubName = props.clubs[0].name
            if (props.clubs.length > 1)
                showClubSelect = true
        }
        setShowClubSelect(showClubSelect)
        props.setClub(clubId, clubName)
        doFilterBranchesByClub(clubId)
    }

    const doFilterBranchesByClub = clubId => {
        let branchId = '-1'
        let branchName = ''
        const branches = props.branches.filter(x => x.clubId === +clubId)
        if (branches.length === 1) {
            branchId = branches[0].branchId
            branchName = branches[0].name
        }
        branches.unshift({ branchId: '-1', name: '', clubId: '-1' })
        setBranches(branches)
        props.setBranch(branchId, branchName)
    }

    const renderBranchNames = _ => {
        return branches.map((branch) => {
            return <option value={branch.branchId} key={branch.branchId}>{branch.name}</option>
        });
    }

    const renderClubNames = _ => {
        return props.clubs.map((club) => {
            return <option value={club.clubId} key={club.clubId}>{club.name}</option>
        })
    }

    return <>
        {showClubSelect && <Col>
            <Label className="mt-4"><strong>{props.reportType === ReportTypes.CrossTerritorySalesReport ? "Sold-To Club" : "Club"}</strong> (a club selection is required)</Label>
            <label className="select">
                <select
                    name="clubName"
                    className="form-control input-editable"
                    value={props.clubId}
                    onChange={(e) => {
                        const text = e.target.options[e.target.selectedIndex].text
                        const value = e.target.value
                        props.setClub(value, text)
                        doFilterBranchesByClub(value)
                    }}
                >
                    {renderClubNames()}
                </select>
            </label>
        </Col>}
        <Col>
            <Label className="mt-4"><strong>{props.reportType === ReportTypes.CrossTerritorySalesReport ? "Sold-To Branch" : "Branch"}</strong></Label>
            <label className="select">
                <select
                    name="branchName"
                    className="form-control input-editable"
                    value={props.branchId}
                    onChange={(e) => {
                        const text = e.target.options[e.target.selectedIndex].text;
                        const value = e.target.value;
                        props.setBranch(value, text)
                    }}
                >
                    {renderBranchNames()}
                </select>
            </label>
        </Col>
    </>
}

export default ClubBranchSelect